module.exports = __webpack_public_path__ + "static/media/cart-full.558ff325.svg";